<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<span class="input-btn">
  <input #fileInput type="file" style="display: none"
    (change)="fileInput.files && getSelectedFile(fileInput.files)" accept=".csv" />
  <button mat-flat-button color="accent" (click)="fileInput.click()">{{inputFileLabel}}</button>
  <div class="selected-file-name">
    <p *ngIf="!selectedFile; else fileName">Please select a file.</p>
    <ng-template #fileName>
      <span>{{selectedFile!.name | longStringTruncate }} </span>
      <mat-icon class="selected-file-close"
        (click)="resetSelectedFile(); fileSelected.emit(null);">
      cancel</mat-icon>
    </ng-template>
  </div>
<span>